'use client'

import { Input } from '@/components/input/input'
import { noOp } from '@/utils/functions/noOp'
import { cn } from '@/utils/styles/cn'

interface IRestaurantsSearchPlaceholderProps {
    onOpen: () => void
    label?: string
    placeholder?: string
    inputClassName?: string
    containerClassName?: string
}

export const RestaurantsSearchPlaceholder = ({
    onOpen,
    label,
    placeholder,
    inputClassName,
    containerClassName,
}: IRestaurantsSearchPlaceholderProps) => (
    <div className={cn('relative w-full md:w-auto flex', containerClassName)}>
        <Input
            label={label}
            value=""
            onValueChange={noOp}
            placeholder={placeholder}
            styleType="white"
            type="search"
            shape="pill"
            inputClassName={cn(
                'min-h-[54px] md:max-w-[350px] min-w-[350px] w-full border-[2px]',
                inputClassName
            )}
            containerClassName="w-full"
            onClick={onOpen}
        />
    </div>
)
